export default {
  addToCart: "افزودن به سبد خرید",
  stock: "موجودی",
  outOfStock: "ناموجود",
  price:"قیمت",
  toman: "تومان",
  showAll: "مشاهده همه",
  retry: "تلاش مجدد",
  urls: {
    ProductCategory: "/product-category",
    Product: "/product",

  }


};
